module.exports = __webpack_public_path__ + "img/home-3.0ae276e4.png";